// extracted by mini-css-extract-plugin
export default {"custom_table_container":"index_custom_table_container__KUKj6","empty_state_text":"index_empty_state_text__kIItw","no_data":"index_no_data__bIWQr"};